import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-payroll',
  version: '1.0.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'getEmployees',
      options: [
        { value: 'getEmployees', name: 'Get Employees' },
        { value: 'getPayslips', name: 'Get Payslips' },
        { value: 'createPayslip', name: 'Create Payslip' },
      ],
    },
    {
      key: 'employeeId',
      label: 'Employee ID',
      type: 'string',
      required: true,
      displayOptions: {
        show: {
          operation: ['getPayslips', 'createPayslip'],
        },
      },
    },
    {
      key: 'payslipData',
      label: 'Payslip Data',
      type: 'json',
      required: true,
      placeholder: '{ "period": "2024-01", "amount": 5000 }',
      displayOptions: {
        show: {
          operation: ['createPayslip'],
        },
      },
    },
    {
      key: 'period',
      label: 'Period',
      type: 'string',
      placeholder: '2024-01',
      description: 'Format: YYYY-MM',
      displayOptions: {
        show: {
          operation: ['getPayslips'],
        },
      },
    },
  ],
};

export default schema;
